<script lang="ts">
</script>

<svelte:head>
	<meta name="title" content="SaaS Kit" />
	<meta
		name="description"
		content="An open-source SaaS starter-kit built with SvelteKit, Supabase, TailwindCSS, Stripe, and shadcn-svelte. Host and scale up to 50,000 customers for free on Supabase and Cloudflare Workers."
	/>
	<meta
		name="keywords"
		content="saas, template, boilerplate, svelte, svelte-kit, supabase, typescript, postgres, postgresql, shadcn-ui, shadcn-svelte, tailwindcss, stripe, open source, free"
	/>
	<meta name="robots" content="index, follow" />
	<link rel="canonical" href="https://84Mayer.com" />
</svelte:head>
